((angular) => {
  'use strict';

  angular
    .module('App')
    .factory('ParticipantService', [
      '$q',
      '$http',
      '$location',
      'jwtHelper',
      'API',
      'dateHelper',
      'AuthService',
      ParticipantService,
    ]);

  function ParticipantService(
    $q,
    $http,
    $location,
    jwtHelper,
    API,
    dateHelper,
    authService
  ) {
    const current = () => {
      const user = authService.getTokenData();
      if (!user) return $q.reject('no-user');

      return $http.get(`${API}/participant`).then((result) => {
        const participant = dateHelper.parseObj(result.data);
        participant.event = dateHelper.parseObj(participant.event);

        return participant;
      });
    };

    const getMarketingActivity = () => {
      const user = authService.getTokenData();
      if (!user) return $q.reject('no-user');

      return $http
        .get(`${API}/participant/getMarketingActivity`)
        .then((result) => {
          const participant = dateHelper.parseObj(result.data);
          participant.event = dateHelper.parseObj(participant.event);

          return participant;
        });
    };

    const confirm = (activityIds) => {
      return $http
        .post(`${API}/participant/confirm`, activityIds)
        .then((result) => result.data);
    };

    const sendInvite = (activityIds) => {
      return $http
        .post(`${API}/participant/sendinvite`, activityIds)
        .then((result) => result.data);
    };

    const save = (participant) => {
      return $http
        .post(`${API}/participant`, participant)
        .then((res) => res.data);
    };

    const hasVoucher = () => {
      return $http
        .get(`${API}/participant/hasVoucher`)
        .then(() => true)
        .catch(() => false);
    };

    const sendInviteActivity = (activityIds) => {
      return $http
        .post(`${API}/participant/sendInviteActivity`, activityIds)
        .then((result) => result.data);
    };

    const companyByEvent = (eventId) => {
      return $http
        .get(`${API}/participant/event/company`, eventId)
        .then((result) => result)
        .catch(() => false);
    };

    return {
      current,
      confirm,
      save,
      hasVoucher,
      sendInvite,
      sendInviteActivity,
      getMarketingActivity,
      companyByEvent,
    };
  }
})(angular);
